import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';

interface ConfirmSignUpFormProps {
  username: string;
  onConfirmSuccess: () => void;
  onBackToSignUp: () => void;
}

const ConfirmSignUpForm: React.FC<ConfirmSignUpFormProps> = ({
  username,
  onConfirmSuccess,
  onBackToSignUp
}) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { confirmSignUp } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await confirmSignUp(username, code);
      onConfirmSuccess();
    } catch (err: any) {
      setError(err.message || 'Failed to confirm sign up');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-form">
      <h2>Confirm Your Account</h2>
      <p>Please enter the verification code sent to your email.</p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="code">Verification Code:</label>
          <input
            type="text"
            id="code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
            disabled={loading}
            placeholder="Enter 6-digit code"
          />
        </div>
        {error && <div className="error-message">{error}</div>}
        <button type="submit" disabled={loading}>
          {loading ? 'Confirming...' : 'Confirm'}
        </button>
      </form>
      <p>
        <button type="button" className="link-button" onClick={onBackToSignUp}>
          Back to Sign Up
        </button>
      </p>
    </div>
  );
};

export default ConfirmSignUpForm;